import { selfAxios } from "@oppein/op-utils";

/**
 * 查询配置列表
 * @param {Object} params
 * @param {string} params.pageNo 页码
 * @param {string} params.pageSize 每页大小
 * @param {string} params.searchKeyWord 搜索关键词
 * @param {string} params.shelfStatus 上架状态
 * @returns {Promise<Object>}
 */
export async function postPersonalizedCheckTypeConfigGetListByQry(params) {
  const { data } = await selfAxios.post(
    `/designordercenter/personalizedCheckTypeConfig/getListByQry`,
    params,
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/designordercenter/personalizedCheckTypeConfig/getListByQry/post.js